//@ts-check
import getHost from '../host';
import stripDesignTrunkFromPath from './stripDesignTrunkFromPath';
/**
 * @type {import("./types").getFilePreviewPathType}
 */

export default (function (_ref) {
  var workspace = _ref.workspace,
      path = _ref.path;
  if (path.indexOf(':') > -1) return "".concat(getHost(), "EOS/PreviewFile/#workspace/").concat(encodeURIComponent(workspace), "/").concat(path);
  return "".concat(getHost(), "EOS/PreviewFile/#workspace/").concat(encodeURIComponent(workspace), "/").concat(stripDesignTrunkFromPath(path));
});